module.exports = __webpack_public_path__ + "static/media/jira.8570e901.svg";